import { render, staticRenderFns } from "./notificationsButton.vue?vue&type=template&id=3bd67310&"
import script from "./notificationsButton.vue?vue&type=script&lang=js&"
export * from "./notificationsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports